export enum TagCategoryEnum {
  PERIOD = "period",
  TRAINING_TAG = "training_tag",
  SESSION_TAG = "session_tag",
}
